import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
}

export const AccordionWrap = styled.div<IProps>`
  .accordion-item {
    .accordion-label {
      position: relative;

      .label {
        ${mixin.flex({ direction: 'row-reverse', justify: 'space-between' })}
        width: 100%;
        text-align: left;
        font-size: 16px;
        padding: 4px 0;
        color: #000;

        span {
          margin-left: 0;
        }

        * {
          pointer-events: none;
        }
      }

      .arrow {
        transition: transform 0.3s;
      }

      [aria-expanded='true'] {
        .arrow {
          transform: rotate(180deg);
        }
      }
    }
  }

  .accordion-more-btn {
    font-size: 11px;
    line-height: 14px;

    svg {
      height: 18px;
      margin-left: 4px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .accordion-item {
      .accordion-label {
        .label {
          font-size: ${mixin.pxToVw('16')};
          padding: ${mixin.pxToVw('4 0')};
        }
      }
    }

    .accordion-more-btn {
      font-size: ${mixin.pxToVw('11')};
      line-height: ${mixin.pxToVw('14')};

      svg {
        height: ${mixin.pxToVw('18')};
        margin-left: ${mixin.pxToVw('4')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .accordion-more-btn {
      font-size: 14px;
      line-height: 15px;

      svg {
        width: 6px;
        height: 18px;
        margin-left: 4px;
      }
    }
  }
`;
